const EditorContextInitial = {
  activeItem: null,
  activeCategory: 'all',
  onSetActiveItem: () => null,
  onSetActiveCategory: () => null
};

export default EditorContextInitial;
